import { ShForm } from '@/components/ui/rjsf/ShForm';
import { JSONConfig } from '@/models/device.models';
import Form from '@rjsf/core';
import { RJSFSchema, UiSchema } from '@rjsf/utils';
import validator from '@rjsf/validator-ajv8';
import { forwardRef } from 'react';

// JSON Schema for Site Configuration
const siteConfigSchema: RJSFSchema = {
  type: 'object',
  properties: {
    Timezone: {
      type: 'string',
      title: 'Timezone',
      enum: Intl.supportedValuesOf('timeZone') ?? [],
    },
    TunnelUrl: {
      type: 'string',
      title: 'Tunnel URL',
      default: '',
    },
    OcrRegions: {
      type: 'array',
      title: 'OCR Regions',
      items: {
        type: 'string',
        enum: ['NSW', 'VIC', 'QLD', 'SA', 'WA', 'NT', 'TAS', 'ACT', 'Alberta'],
      },
      uniqueItems: true,
    },
  },
  required: ['Timezone', 'OcrRegions'],
};

const siteConfigUiSchema: UiSchema = {
  Timezone: {
    'ui:widget': 'select',
    'ui:placeholder': 'E.g. Select timezone...',
  },
  TunnelUrl: {
    'ui:emptyValue': '',
    'ui:placeholder': 'E.g. https://example.com/tunnel',
  },
  OcrRegions: {
    'ui:widget': 'select',
    'ui:placeholder': 'E.g. Select OCR regions...',
    'ui:options': {
      multiple: true,
    },
  },
};

interface SiteConfigFormProps {
  formData?: JSONConfig;
  readonly?: boolean;
}

const SiteConfigForm = forwardRef<
  Form<JSONConfig, RJSFSchema, JSONConfig>,
  SiteConfigFormProps
>(({ formData, readonly }, ref) => {
  return (
    <ShForm
      ref={ref}
      validator={validator}
      formData={formData}
      readonly={readonly}
      schema={siteConfigSchema}
      uiSchema={{
        ...siteConfigUiSchema,
        'ui:submitButtonOptions': { norender: true },
      }}
    />
  );
});

SiteConfigForm.displayName = 'SiteConfigForm';

export { siteConfigSchema, siteConfigUiSchema };
export default SiteConfigForm;
